export default __webpack_public_path__ + "static/media/036-astronomy.b3e6fb1c.svg";